module.exports = __webpack_public_path__ + "static/media/joblypreview.30fc7195.png";